import { type FC, type ReactNode } from 'react';

import styles from './GeoLayout.css';

interface IGeoLayoutProps {
  address: ReactNode;
  parent: ReactNode;
  specialGeo: ReactNode;
}

export const GeoLayout: FC<IGeoLayoutProps> = ({ address, parent, specialGeo }) => {
  return (
    <div className={styles['geo-layout']}>
      <div className={styles['geo-layout__address']}>{address}</div>
      <div className={styles['geo-layout__parent']}>{parent}</div>
      <div className={styles['geo-layout__special-geo']}>{specialGeo}</div>
    </div>
  );
};
